import { InternalAxiosRequestConfig } from 'axios';
import keycloakService from './keycloak-service';
import { logInfo, logError } from '../utils';

/**
 * Interceptor for adding authentication token to requests
 * @param config The request configuration
 * @returns The updated request configuration
 */
export const authInterceptor = async (
  config: InternalAxiosRequestConfig
): Promise<InternalAxiosRequestConfig> => {
  try {
    // Check if Keycloak is authenticated
    if (keycloakService.isAuthenticated()) {
      // Try to update the token if it's about to expire
      await keycloakService.updateToken(60);

      // Get the token
      const token = keycloakService.getToken();

      if (token) {
        // Add the token to the request headers
        config.headers = config.headers || {};
        config.headers['Authorization'] = `Bearer ${token}`;
        logInfo(
          `Added authentication token to request: ${config.method?.toUpperCase()} ${config.url}`
        );
      }
    }

    return config;
  } catch (error) {
    logError('Error in auth interceptor:', error);
    return config;
  }
};
